export interface GuidedTourStep {
	menuId: string;
	route: string;
	titleKey: string;
	descriptionKey: string;
	/** Seletor CSS do alvo. Se ausente, usa [data-menu-id="menuId"] (item do sidebar). */
	element?: string;
}

export interface PageDescription {
	descriptionKey: string;
}

/**
 * Steps do tour guiado sequencial.
 * Cada step destaca um item do sidebar (via data-menu-id) e navega para a rota.
 */
export const guidedTourSteps: GuidedTourStep[] = [
	{
		menuId: "dashboard",
		route: "/dashboard",
		titleKey: "tours.guided.dashboard.title",
		descriptionKey: "tours.guided.dashboard.description",
	},
	{
		menuId: "consultants",
		route: "/consultants",
		titleKey: "tours.guided.consultants.title",
		descriptionKey: "tours.guided.consultants.description",
	},
	{
		menuId: "mediums",
		route: "/mediums",
		titleKey: "tours.guided.mediums.title",
		descriptionKey: "tours.guided.mediums.description",
	},
	{
		menuId: "journeyStages",
		route: "/journey-stages",
		titleKey: "tours.guided.journeyStages.title",
		descriptionKey: "tours.guided.journeyStages.description",
	},
	{
		menuId: "functions",
		route: "/functions",
		titleKey: "tours.guided.functions.title",
		descriptionKey: "tours.guided.functions.description",
	},
	{
		menuId: "member-groups",
		route: "/member-groups",
		titleKey: "tours.guided.memberGroups.title",
		descriptionKey: "tours.guided.memberGroups.description",
	},
	{
		menuId: "spiritual-lines",
		route: "/spiritual-lines",
		titleKey: "tours.guided.spiritualLines.title",
		descriptionKey: "tours.guided.spiritualLines.description",
	},
	{
		menuId: "guides",
		route: "/guides",
		titleKey: "tours.guided.guides.title",
		descriptionKey: "tours.guided.guides.description",
	},
	{
		menuId: "orixas",
		route: "/orixas",
		titleKey: "tours.guided.orixas.title",
		descriptionKey: "tours.guided.orixas.description",
	},
	{
		menuId: "attendance-types",
		route: "/attendance-types",
		titleKey: "tours.guided.attendanceTypes.title",
		descriptionKey: "tours.guided.attendanceTypes.description",
	},
	{
		menuId: "ritual-types",
		route: "/ritual-types",
		titleKey: "tours.guided.ritualTypes.title",
		descriptionKey: "tours.guided.ritualTypes.description",
	},
	{
		menuId: "rituals",
		route: "/rituals",
		titleKey: "tours.guided.rituals.title",
		descriptionKey: "tours.guided.rituals.description",
	},
	{
		menuId: "financial-dashboard",
		route: "/financial",
		titleKey: "tours.guided.financialDashboard.title",
		descriptionKey: "tours.guided.financialDashboard.description",
	},
	{
		menuId: "financial-funds",
		route: "/financial/funds",
		titleKey: "tours.guided.financialFunds.title",
		descriptionKey: "tours.guided.financialFunds.description",
	},
	{
		menuId: "financial-movements",
		route: "/financial/movements",
		titleKey: "tours.guided.financialMovements.title",
		descriptionKey: "tours.guided.financialMovements.description",
	},
	{
		menuId: "financial-reports",
		route: "/financial/reports",
		titleKey: "tours.guided.financialReports.title",
		descriptionKey: "tours.guided.financialReports.description",
	},
	{
		menuId: "temple-settings",
		route: "/temple/settings",
		titleKey: "tours.guided.templeSettings.title",
		descriptionKey: "tours.guided.templeSettings.description",
	},
	{
		menuId: "temple-users",
		route: "/temple/users",
		titleKey: "tours.guided.templeUsers.title",
		descriptionKey: "tours.guided.templeUsers.description",
	},
	{
		menuId: "temple-invites",
		route: "/temple/invites",
		titleKey: "tours.guided.templeInvites.title",
		descriptionKey: "tours.guided.templeInvites.description",
	},
	{
		menuId: "billing",
		route: "/temple/plan",
		titleKey: "tours.guided.billing.title",
		descriptionKey: "tours.guided.billing.description",
	},
	{
		menuId: "display-messages",
		route: "/temple/display-messages",
		titleKey: "tours.guided.displayMessages.title",
		descriptionKey: "tours.guided.displayMessages.description",
	},
	{
		menuId: "wisdom-quotes",
		route: "/temple/wisdom-quotes",
		titleKey: "tours.guided.wisdomQuotes.title",
		descriptionKey: "tours.guided.wisdomQuotes.description",
	},
	{
		menuId: "temple-import",
		route: "/temple/import",
		titleKey: "tours.guided.import.title",
		descriptionKey: "tours.guided.import.description",
	},
	{
		menuId: "support",
		route: "/support",
		titleKey: "tours.guided.support.title",
		descriptionKey: "tours.guided.support.description",
	},
	{
		menuId: "assistant",
		route: "/dashboard",
		element: '[data-tour="assistant"]',
		titleKey: "tours.guided.assistant.title",
		descriptionKey: "tours.guided.assistant.description",
	},
];

/**
 * Descrições por route name (para o help button no footer).
 */
export const pageDescriptions: Record<string, PageDescription> = {
	Dashboard: { descriptionKey: "tours.pages.Dashboard" },
	Consultants: { descriptionKey: "tours.pages.Consultants" },
	Mediums: { descriptionKey: "tours.pages.Mediums" },
	SpiritualLines: { descriptionKey: "tours.pages.SpiritualLines" },
	Guides: { descriptionKey: "tours.pages.Guides" },
	Orixas: { descriptionKey: "tours.pages.Orixas" },
	RitualTypes: { descriptionKey: "tours.pages.RitualTypes" },
	Rituals: { descriptionKey: "tours.pages.Rituals" },
	JourneyStages: { descriptionKey: "tours.pages.JourneyStages" },
	Functions: { descriptionKey: "tours.pages.Functions" },
	MemberGroups: { descriptionKey: "tours.pages.MemberGroups" },
	AttendanceTypes: { descriptionKey: "tours.pages.AttendanceTypes" },
	FinancialDashboard: { descriptionKey: "tours.pages.FinancialDashboard" },
	FinancialFunds: { descriptionKey: "tours.pages.FinancialFunds" },
	FinancialMovements: { descriptionKey: "tours.pages.FinancialMovements" },
	FinancialReports: { descriptionKey: "tours.pages.FinancialReports" },
	TempleSettings: { descriptionKey: "tours.pages.TempleSettings" },
	TempleUsers: { descriptionKey: "tours.pages.TempleUsers" },
	TempleInvites: { descriptionKey: "tours.pages.TempleInvites" },
	WisdomQuotes: { descriptionKey: "tours.pages.WisdomQuotes" },
	Billing: { descriptionKey: "tours.pages.Billing" },
	DisplayMessages: { descriptionKey: "tours.pages.DisplayMessages" },
	Import: { descriptionKey: "tours.pages.Import" },
	Support: { descriptionKey: "tours.pages.Support" },
};
